import React, { useEffect, useState } from "react";
import BaseViewModel from "../../base/BaseViewModel";

function useNotFound() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_HOST}/api/content/`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((response) => {
        setContent(response);
      })
      .catch((error) => console.log(error));
  }, []);

  return {
    content,
    setContent,
  };
}

const NotFoundViewModel = BaseViewModel(useNotFound);

export default NotFoundViewModel;
